export default (min: number, max: number, rate: number) => ({
  minPrice: Math.floor((min * rate) / 100.0) * 100,
  maxPrice: Math.ceil((max * rate) / 100.0) * 100,
});
